import { render, staticRenderFns } from "./LoginForms.vue?vue&type=template&id=4b961c9f&scoped=true"
import script from "./LoginForms.vue?vue&type=script&lang=js"
export * from "./LoginForms.vue?vue&type=script&lang=js"
import style0 from "./LoginForms.vue?vue&type=style&index=0&id=4b961c9f&prod&lang=scss&scoped=true"
import style1 from "./LoginForms.vue?vue&type=style&index=1&id=4b961c9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b961c9f",
  null
  
)

export default component.exports